import { render, staticRenderFns } from "./v-footer.vue?vue&type=template&id=97943806&scoped=true"
import script from "./v-footer.vue?vue&type=script&lang=js"
export * from "./v-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97943806",
  null
  
)

export default component.exports